import React from "react";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import imagenAlex from "../static/images/alex_rodriguez.png";

export default function About() {
  return (
    <section className="about" id="about">
      <div className="section__container">
        <div className="section__header">
          <span className="section__tag">Who am I</span>
          <h2 className="section__title">About Me</h2>
        </div>
        <div className="about__content">
          <div className="about__image">
            <div className="about__image-wrapper">
              <img src={imagenAlex} alt="Alex Rodriguez" />
              <div className="about__image-border"></div>
            </div>
          </div>
          <div className="about__info">
            <h3 className="about__name">Alex Rodriguez</h3>
            <p className="about__role">Software Developer at CHECK24</p>
            <p className="about__bio">
              Full-stack developer based in Augsburg, Germany, passionate about building
              clean, performant, and scalable web applications. Since joining CHECK24
              Vergleichsportal Mietwagen GmbH in September 2022, I've grown from a
              frontend specialist into a full-stack developer working within a
              high-traffic enterprise environment — shipping real features used by
              thousands of users every day.
            </p>
            <p className="about__bio">
              Working at enterprise scale has sharpened my skills across the entire
              stack: from building robust PHP backends with Laminas and Symfony, to
              containerizing services with Docker, maintaining CI/CD pipelines via
              Bitbucket Pipelines, and collaborating in agile Scrum teams with a strong
              focus on code quality and best practices. I thrive where clean
              architecture meets great user experience.
            </p>
            <div className="about__details">
              <div className="about__detail">
                <FiMapPin />
                <span>Augsburg, Germany</span>
              </div>
              <div className="about__detail">
                <FiPhone />
                <span>+49 163 3833515</span>
              </div>
              <div className="about__detail">
                <FiMail />
                <span>alex.rodriguez.vera@hotmail.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
